var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 1.66667V18.3333C19.1663 18.7754 18.9907 19.1993 18.6782 19.5118C18.3656 19.8244 17.9417 20 17.4997 20H13.333C12.891 20 12.4671 19.8244 12.1545 19.5118C11.8419 19.1993 11.6663 18.7754 11.6663 18.3333V1.66667C11.6663 1.22464 11.8419 0.800716 12.1545 0.488155C12.4671 0.175595 12.891 0 13.333 0H17.4997C17.9417 0 18.3656 0.175595 18.6782 0.488155C18.9907 0.800716 19.1663 1.22464 19.1663 1.66667ZM6.66634 0H2.49967C2.05765 0 1.63372 0.175595 1.32116 0.488155C1.0086 0.800716 0.833008 1.22464 0.833008 1.66667V18.3333C0.833008 18.7754 1.0086 19.1993 1.32116 19.5118C1.63372 19.8244 2.05765 20 2.49967 20H6.66634C7.10837 20 7.53229 19.8244 7.84485 19.5118C8.15741 19.1993 8.33301 18.7754 8.33301 18.3333V1.66667C8.33301 1.22464 8.15741 0.800716 7.84485 0.488155C7.53229 0.175595 7.10837 0 6.66634 0Z",
    fill: "#C06674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon_pause.f2b04d301f956d2843dabdbfb22dbbad.svg";
export { ForwardRef as ReactComponent };